import { render, staticRenderFns } from "./AgencyProjectChangesHistory.vue?vue&type=template&id=20cbf240&scoped=true&"
import script from "./AgencyProjectChangesHistory.vue?vue&type=script&lang=js&"
export * from "./AgencyProjectChangesHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cbf240",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDataTable})
